import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../apiSetup/apiCall';

export const fetchAddCouponForm = createAsyncThunk('addoupon/fetchAddouponForm', async (_,{ rejectWithValue }) => {
    try {
        const response = await api.get('/prometheus/station/add/coupon/');
        return response.data;
    } catch (error) {
        console.error('Error fetching coupon form', error);
        throw rejectWithValue(error);
    }
    });

const AddCouponSlice = createSlice({
  name: 'addCoupon',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddCouponForm.pending, (state) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(fetchAddCouponForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchAddCouponForm.rejected, (state, action) => {
        state.isLoading = false;
        state.data = []
        state.error = true
      });
  },
});

export default AddCouponSlice.reducer;
